import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api/booking`;

export const bookingApi = {
  getConfig: async () => {
    const { data } = await axios.get(`${API}/config`);
    return data;
  },
  listServices: async () => {
    const { data } = await axios.get(`${API}/services`);
    return data.services || [];
  },
  getPopular: async () => {
    const { data } = await axios.get(`${API}/popular`);
    return [...(data.ranked || []), data.fallback].filter(Boolean);
  },
  getTaxRates: async () => {
    const { data } = await axios.get(`${API}/tax-rates`);
    return data;
  },
  searchAvailability: async ({ variation_id, start_at, end_at }) => {
    const { data } = await axios.post(`${API}/availability`, {
      variation_id,
      start_at,
      end_at,
    });
    return data.slots || [];
  },
  createBooking: async (payload) => {
    const { data } = await axios.post(`${API}/create`, payload);
    return data;
  },
};
